import React from 'react';
import { Button, Popconfirm, Space, Table } from 'antd';
import {
  useDeleteNakshatramSubTemple,
  useGetNakshatramSubTemples,
} from '../../services/nakshatram/sub-temple/nakshatram-sub-temple.service.hook';
import TmsNakshatramSubTempleCreateModal from './tms-nakshatram-sub-temple-create-modal';
import { useParams } from 'react-router';
import { useGetNakshatramById } from '../../services/nakshatram/nakshatram.service.hook';

const TMSNakshatramSubTemple = () => {
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(10);

  const params = useParams();

  const { data: subTemples, isLoading } = useGetNakshatramSubTemples(
    params.nakshatramId,
    page,
    limit
  );

  const { data: nakshatram } = useGetNakshatramById(params.nakshatramId);

  const { mutate: deleteSubTemple, isPending: isDeleteLoading } =
    useDeleteNakshatramSubTemple();

  const [showCreateModal, setShowCreateModal] = React.useState(false);

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
  };

  const handleDelete = (record) => {
    deleteSubTemple({ id: record.id });
  };

  const columns = [
    {
      title: 'Short Name',
      dataIndex: ['subTemple', 'shortName'],
      key: ['subTemple', 'shortName'],
    },
    {
      title: 'Name',
      dataIndex: ['subTemple', 'name'],
      key: ['subTemple', 'name'],
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Space size='middle'>
          <Popconfirm
            title='Are you sure？'
            okText='Yes'
            cancelText='No'
            onConfirm={() => handleDelete(record)}
          >
            <a style={{ color: 'red' }}>Delete</a>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div style={{ float: 'left', marginBottom: '5px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              marginRight: '5px',
              fontWeight: 'bold',
              fontSize: '22px',
            }}
          >
            {' '}
            {nakshatram?.name} Nakshatram
          </div>
          <Button onClick={() => setShowCreateModal(true)} type='primary'>
            Assign Sub Temple
          </Button>
        </div>
      </div>
      <div>
        <Table
          size='small'
          columns={columns}
          dataSource={subTemples?.items}
          loading={isLoading || isDeleteLoading}
          onChange={handleTableChange}
          pagination={{
            current: page,
            pageSize: limit,
            total: subTemples?.meta?.totalItems,
          }}
        />
      </div>
      <TmsNakshatramSubTempleCreateModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        nakshatramId={params.nakshatramId}
        nakshatram={nakshatram}
      />
    </>
  );
};

export default TMSNakshatramSubTemple;
